import { useQuery } from 'react-query';

import { ML_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';

import type { SessionInfo } from './useFetchSessionById';

export const QUERY_KEY = 'askneedl-sessions';

export const useFetchAllSession = (q?: string) => {
  return useQuery(
    [QUERY_KEY, q],
    () =>
      axiosInstance.get<ResponseType>(ML_API_ROUTES.askNeedlSessions(), {
        params: { q },
      }),
    {
      select: (response) => response?.data?.sessions || [],
    }
  );
};

type ResponseType = {
  sessions: SessionInfo[];
};
